import React, { useState } from 'react';
import PropTypes           from 'prop-types';

const TagInput = (props) => {
  const { placeholder, value, onChange, onEnter, styles, passClearStateFunc } = props;
  const [inputTag, setInputTag] = useState('');
  const [tags, setTags] = useState(value || []);

  const clearState = () => {
    setInputTag('');
    setTags([]);
  }

  if (passClearStateFunc) passClearStateFunc(clearState);

  const handleKeyDown = e => {
    if (e.keyCode === 13 && e.target.value !== '')  {
      e.preventDefault();
      if(onEnterPress(e.target.value)) {
        const newTags = [...tags, inputTag.trim()];
        setTags(newTags);
        setInputTag('');
        onChange(newTags);
      }
    }
  }

  const onEnterPress = tag => {
    if(typeof onEnter === 'function') {
      return onEnter(tag);
    }
    return true;
  }

  const handleRemoveTag = index => {
    const newTags = [...tags];

    newTags.splice(index, 1);
    setTags(newTags);
    setInputTag('');
    onChange(newTags);
  }

  return (
    <div className={`tags-input ${styles || ''}`}>
      {tags && tags.map((tag, index) => (
        <span className='tag' key={index}>
          {tag}
          <button className='remove' onClick={() => handleRemoveTag(index)} />
        </span>
      ))}
      <input
        type='text'
        placeholder={placeholder || ''}
        value={inputTag}
        onChange={e => setInputTag(e.target.value)}
        onKeyDown={handleKeyDown} 
      />
    </div>
  );
}

TagInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
  passClearStateFunc: PropTypes.func
};

export default TagInput;
